// export interface tabData=tabDataItem[]
export var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["ONLINE"] = "ONLINE";
    DeviceStatus["OFFLINE"] = "OFFLINE";
    DeviceStatus["UNUSUAL"] = "UNUSUAL";
})(DeviceStatus || (DeviceStatus = {}));
export var TaskStatusType;
(function (TaskStatusType) {
    TaskStatusType["ENABLE"] = "ENABLE";
    TaskStatusType["DISABLE"] = "DISABLE";
    TaskStatusType["ERROR"] = "ERROR";
})(TaskStatusType || (TaskStatusType = {}));
